import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import {imageMap} from "../../../../images/imageMap.ts";
import Icon from "../../../../components/selfcare/Icon.tsx";
import Routing from "../../../../Routing.ts";
import IconDankort from "../../../../components/icons/IconDankort.tsx";
import IconVisa from "../../../../components/icons/IconVisa.tsx";
import IconVisaElectron from "../../../../components/icons/IconVisaElectron.tsx";
import IconMastercard from "../../../../components/icons/IconMastercard.tsx";
import IconArrow from "../../../../components/icons/IconArrow.tsx";

export default function BetalingsMulighederArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article article--connect">
                    <div className="paragraph">
                        <p>
                            Som kunde hos os betaler du dine regninger med Dankort, Visa, Visa Electron eller Mastercard via automatisk kortbetaling.
                        </p>
                    </div>
                </div>
                <div className="article article--connect">
                    <div className="grid faq-cards-grid">
                        <Icon component={IconDankort} />
                        <Icon component={IconVisa} />
                        <Icon component={IconVisaElectron} />
                        <Icon component={IconMastercard} />
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <p>
                            Når du opretter dig som kunde, tilmelder du dit betalingskort til løbende abonnementsbetaling.
                            Med automatisk kortbetaling slipper du for ekstra gebyrer og du er sikker på at regningen bliver betalt automatisk hver måned.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvordan skifter jeg mit betalingskort?</h2>
                        <p>
                            Du kan nemt skifte dit betalingskort i <Link to={Routing.Selfcare.Card}>Mit Hiper</Link>.
                        </p>
                    </div>
                    <img
                        className="paragraph-image br1 box-shadow"
                        src={imageMap.help.subscription.selfcare_card}
                        alt="Grafik af betalingskortoversigten."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Kan jeg betale med PBS?</h2>
                        <p>
                            Du kan ikke betale dit abonnement med PBS.
                            Du kan kun betale med automatisk kortbetaling.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Kan min arbejdsgiver betale for mit internet?</h2>
                        <p>
                            Ja, din arbejdsgiver kan godt betale for dit internet.
                            Det er også muligt at indgå en firmaaftale med os.
                            Tryk på linket nedenunder for at læse hvordan.
                        </p>
                        <div className={'button-container'}>
                            <Link
                                className={'button button--montserrat with-icon teal'}
                                to={"/hjaelp/regning-og-betaling/internet-betalt-af-arbejdsgiver"}
                            >
                                <span className={'text'}>
                                    Firma betalt internet og firmaaftale
                                </span>
                                <Icon component={IconArrow}/>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Jeg har mistet mit betalingskort &ndash; hvad gør jeg?</h2>
                        <p>
                            Kontakt os hurtigst muligt så vi kan aftale, hvornår du kan betale din næste regning.
                            Ofte kan vi udsætte regningen, indtil du modtager det nye kort.
                        </p>
                        <p>
                            Hvis du ikke kontakter os, vil vi automatisk forsøge at trække pengene på det mistede kort.
                            Hvis betalingen ikke går igennem, kan du få op til 2 rykkergebyrer.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "regning-og-betaling",
                        "article": "internet-betalt-af-arbejdsgiver",
                        "name": "Firma betalt internet"
                    },
                    {
                        "category": "regning-og-betaling",
                        "article": "mistet-kort",
                        "name": "Jeg har mistet mit betalingskort"
                    },
                    {
                        "category": "regning-og-betaling",
                        "article": "forstaa-din-regning",
                        "name": "Forstå din regning"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "mit-hiper",
                        "name": "Mit Hiper"
                    }
                ]}
            />
        </>
    )
}
